import React, { useEffect, useState, useMemo } from "react";
import CourseDetailsPageHeader from "../../EnglishCourseDetails/CourseDetailsPageHeader/CourseDetailsPageHeader";
import FrenchContent from "../FrenchContent/FrenchContent";
import "../../../App.css";
import { useOutletContext } from "react-router-dom";
import LoadingSpinner from "../../../shared/components/LoadingSpinner/LoadingSpinner";

const FrenchPageDetails = () => {
  const [isLoading, setIsLoading] = useState(true);
  const outletContext = useOutletContext() || {};
  const setContentLoaded = useMemo(
    () => outletContext.setContentLoaded || (() => {}),
    [outletContext.setContentLoaded]
  );

  useEffect(() => {
    // Simulate loading for 1500ms (adjust as needed)
    const timer = setTimeout(() => {
      setIsLoading(false);
      // Signal that this page is loaded.
      setContentLoaded(true);
    }, 1500);
    return () => clearTimeout(timer);
  }, [setContentLoaded]);

  if (isLoading) {
    return (
      <div style={{ margin: "auto" }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="courseMaterialsPage">
      <CourseDetailsPageHeader title="SCA French Course Materials" />
      <FrenchContent />
    </div>
  );
};

export default FrenchPageDetails;
